import { Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private spinner: NgxSpinnerService,private toastr: ToastrService) { }

  showLoader(){
    this.spinner.show();
  }
  hideLoader(){
    this.spinner.hide();
  }
  toastSuccess(message){
      this.toastr.success('Success', message); 
  }
  toastError(message){
    this.toastr.error('Error!', message); 
  }
  toasterror(message){
    this.toastr.error('Error!', message,{timeOut:0}); 
  }
 
  toastWarning(message){
    this.toastr.warning(message, 'Warning'); 
  }
}
